import React from "react";

import { Badge, Typography, makeStyles } from "@material-ui/core";
export interface LabelProps {
  labelText?: string;
  IsRequired?: boolean;
}

const useStyles = makeStyles((theme) => ({
  dot: {
    height: 5,
    minWidth: 5
  }
}));

export default function Label(props: LabelProps) {
  const classes = useStyles();
  var {
    labelText,
    IsRequired
  } = props;


  if (labelText) {
    labelText = labelText.replace(/([a-z])([A-Z])/g, '$1 $2');
    labelText = labelText.replace(/([A-Z])([A-Z][a-z])/g, '$1 $2')
    if (labelText.endsWith('Id')) {
      labelText = labelText.substr(0, labelText.length - 3)
    }
  }

  return (
    <Badge color="error" variant="dot" invisible={!IsRequired} style={{ zIndex: 0, }} classes={{ dot: classes.dot }}   >
      <Typography
        style={{
          textAlign: "start",
          fontSize: 12,
        }}
      >
        {labelText}
      </Typography>
    </Badge>
  )
}

